// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_purchase_order_status_enum */
var InvPurchaseOrderStatusEnum;
(function (InvPurchaseOrderStatusEnum) {
    InvPurchaseOrderStatusEnum["DRAFT"] = "DRAFT";
    InvPurchaseOrderStatusEnum["ORDERED"] = "ORDERED";
    InvPurchaseOrderStatusEnum["PARTIALLY_RECEIVED"] = "PARTIALLY_RECEIVED";
    InvPurchaseOrderStatusEnum["RECEIVED"] = "RECEIVED";
    InvPurchaseOrderStatusEnum["CANCELLED"] = "CANCELLED";
})(InvPurchaseOrderStatusEnum || (InvPurchaseOrderStatusEnum = {}));
;
export default InvPurchaseOrderStatusEnum;
/** Zod schema for inv_purchase_order_status_enum */
export const invPurchaseOrderStatusEnum = z.nativeEnum(InvPurchaseOrderStatusEnum);
//# sourceMappingURL=InvPurchaseOrderStatusEnum.js.map